// routeKey(pathname): the identity of the PAGE a URL shows, as opposed to
// the URL itself (round 6 #1).
//
// Layout keys the routed pane (its error boundary and the fade wrapper) on
// this value. A new key remounts the page; the same key re-renders it in
// place. Keying on the raw pathname meant a page whose sections are path
// segments was torn down on every section click:
//   - the patient chart (/patients/:id/:tab) re-read its header, summary,
//     section counts and Overview facts (about 17 requests) and wrote its
//     open-time read audit again on every tab click;
//   - Care Management (/care-management/:tab) re-ran its five badge reads
//     before the section's own.
// Both pages already derive the section from the URL and key their effects
// on the patient id (chart) or the tab (CM), so they re-render in place.
//
// Rules:
//   /patients/:id and anything under it  -> "/patients/:id"  (one chart per patient;
//                                             a different patient is a new page)
//   /care-management and /care-management/:tab -> "/care-management"
//     except the single-segment routes that are separate pages in App.jsx
//     (copilot, supervisor, my-scorecard) and every deeper path (the VBP
//     contract pages, supervisor/cm/:userId), which keep their own pathname.
//   anything else                         -> the pathname
// A trailing slash is ignored so /patients/x and /patients/x/ are one page.

// /care-management/<segment> paths that App.jsx routes to their own page
// component, not to CareManagementView's :tab. Keep in step with App.jsx.
const CM_OWN_PAGES = new Set(["copilot", "supervisor", "my-scorecard", "vbp-contracts"]);

export function routeKey(pathname) {
  const path = String(pathname || "/").replace(/\/+$/, "") || "/";
  const parts = path.split("/");
  // ["", "patients", ":id", ...]
  if (parts[1] === "patients" && parts[2]) return "/patients/" + parts[2];
  if (parts[1] === "care-management") {
    if (parts.length === 2) return "/care-management";
    if (parts.length === 3 && !CM_OWN_PAGES.has(parts[2])) return "/care-management";
  }
  return path;
}
